import { Injectable, Inject } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JwtHelper } from 'angular2-jwt';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class AuthService {
  myAppUrl: string = "";

  constructor(
    private http: HttpClient, private _jwtHelper: JwtHelper,
    @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  //** Login
  getAuth(user) {
    return this.http.post(this.myAppUrl + 'api/auth/login', user, {
      headers: new HttpHeaders({
        "Content-Type": "application/json; charset=utf-8"
      })
    }).map(res => res)
      .catch(this.errorHandler);
  }

  getAuthLoginName() {
    let token: string = localStorage.getItem("jwt");
    if (token && !this._jwtHelper.isTokenExpired(token)) {
      let user = this._jwtHelper.decodeToken(token);
      return user.UserName;
    }
    else {
      return 0;
    }
  }

  resetAuthLoginName() {
    let token: string = localStorage.getItem("jwt");
    if (token && !this._jwtHelper.isTokenExpired(token)) {
      let user = this._jwtHelper.decodeToken(token);
      return user.UserName;
    }
    else {
      return 0;
    }
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}  



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts